var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCardGrid',{attrs:{"layout":"1-2-2","skeletonsConfig":_vm.skeletonsConfig,"loading":_vm.loading}},_vm._l((3),function(i){return _c('Card',{key:i,attrs:{"headingLevel":5,"prependTitle":`(${i})`}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }